import { WorkTask } from "../../types/ganttChart";
import labels from "../../utils/labels";
import VisitHoursListItem from "./VisitHoursListItem";
import drawerStyles from "../../styles/drawer.module.css";

/**
 * The original Nexus preferred and allowed windows, shown for reference below
 * the Besøgstid legend when the citizen's other appointments narrowed what was
 * sent to planning. No swatch — the timeline draws the narrowed windows, not
 * these.
 */
const VisitHoursOriginalWindows = ({ task }: { task: WorkTask }) => {
  return (
    <div className="VisitHoursOriginalWindows gap-1 flex flex-col">
      <div className={drawerStyles.visitHoursDivider}></div>
      <VisitHoursListItem
        start={task.preferredEarliestStart}
        end={task.preferredLatestEnd}
        label={labels.originalPreferredTime}
        hasSwatch={false}
      />
      <VisitHoursListItem
        start={task.earliestStart}
        end={task.latestEnd}
        label={labels.originalAllowedTime}
        hasSwatch={false}
      />
    </div>
  );
};

export default VisitHoursOriginalWindows;
